// import { distance, point } from '@turf/turf';

export function getAreaCorners() {
    // coords: {
    //     lat: number;
    //     lng: number;
    //     xPercent: number;
    //     yPercent: number;
    //     hiddenLat?: number;
    //     hiddenLng?: number;
    // }[]
    // coords = coords.sort((a, b) => a.lng - b.lng);
    // const lngDistances = [];
    // const latDistances = [];
    // coords.forEach((coord, index) => {
    //     if (index < coords.length - 1) {
    //         const nextCoord = coords[index + 1];
    //         // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //         const options: any = { units: 'kilometers' };

    //         //lng
    //         const fromLng = point([coord.lng, coord.lat]);
    //         const toLng = point([nextCoord.lng, coord.lat]);
    //         const distanceLng = distance(fromLng, toLng, options);
    //         const distancePerLng = distanceLng / Math.abs(nextCoord.xPercent - coord.xPercent);
    //         console.log('Distance Lng', distanceLng, distancePerLng);
    //         lngDistances.push(distancePerLng);

    //         //lat
    //         const fromLat = point([coord.lng, coord.lat]);
    //         const toLat = point([coord.lng, nextCoord.lat]);
    //         const distanceLat = distance(fromLat, toLat, options);
    //         const distancePerLat = distanceLat / Math.abs(nextCoord.yPercent - coord.yPercent);
    //         console.log('Distance Lat', distanceLat, distancePerLat);
    //         latDistances.push(distancePerLat);
    //     }
    // });

    // console.log('lngDistances', lngDistances);
    // console.log('latDistances', latDistances);

    // //get average lng
    // const averageLng = lngDistances.reduce((a, b) => a + b, 0) / lngDistances.length;
    // console.log('averageLng', averageLng);

    // //get average lat
    // const averageLat = latDistances.reduce((a, b) => a + b, 0) / latDistances.length;
    // console.log('averageLat', averageLat);

    // //topLeft
    // const nearestTopLeft = coords.reduce((prev, current) =>
    //     prev.lng < current.lng ? prev : current
    // );
    // const shiftedLng = nearestTopLeft.lng - nearestTopLeft.xPercent * averageLng;
    // const topLeft = point([shiftedLng, nearestTopLeft.lat]);

    // //topRight
    // const nearestTopRight = coords.reduce((prev, current) =>
    //     prev.lng > current.lng ? prev : current
    // );
    // const shiftedLng2 = nearestTopRight.lng + (100 - nearestTopRight.xPercent) * averageLng;
    // const topRight = point([shiftedLng2, nearestTopRight.lat]);

    // //bottomRight
    // const nearestBottomRight = coords.reduce((prev, current) =>
    //     prev.lat < current.lat ? prev : current
    // );
    // const shiftedLat = nearestBottomRight.lat - nearestBottomRight.yPercent * averageLat;
    // const bottomRight = point([nearestBottomRight.lng, shiftedLat]);

    // //bottomLeft
    // const nearestBottomLeft = coords.reduce((prev, current) =>
    //     prev.lat > current.lat ? prev : current
    // );
    // const shiftedLat2 = nearestBottomLeft.lat + (100 - nearestBottomLeft.yPercent) * averageLat;
    // const bottomLeft = point([nearestBottomLeft.lng, shiftedLat2]);

    // return {
    //     topLeft: {
    //         lat: topLeft.geometry.coordinates[1],
    //         lng: topLeft.geometry.coordinates[0]
    //     },
    //     topRight: {
    //         lat: topRight.geometry.coordinates[1],
    //         lng: topRight.geometry.coordinates[0]
    //     },
    //     bottomRight: {
    //         lat: bottomRight.geometry.coordinates[1],
    //         lng: bottomRight.geometry.coordinates[0]
    //     },
    //     bottomLeft: {
    //         lat: bottomLeft.geometry.coordinates[1],
    //         lng: bottomLeft.geometry.coordinates[0]
    //     }
    // };

    return {
        topLeft: {
            lat: 0,
            lng: 0
        },
        topRight: {
            lat: 0,
            lng: 0
        },
        bottomRight: {
            lat: 0,
            lng: 0
        },
        bottomLeft: {
            lat: 0,
            lng: 0
        }
    };
}
